import { Injectable } from "@angular/core";
import { Settings } from "../../config/settings";
import { Document } from "@xanadu/model";

@Injectable({
    providedIn: 'root'
})
export class UrlHelper {
    constructor(
        private readonly settings: Settings
    ) {
    }

    public of(path: string): string {
        return `${this.settings.value.urlApi}/${path}`;
    }

    public for<T extends Document>(type: new (x: any) => T): string {
        const typeName = (type as any)._type as string; // Access the custom metadata
        if (!typeName) {
            throw new Error(`Class ${type.name} does not have a _type defined.`);
        }
        return `${this.settings.value.urlApi}/${typeName.toLowerCase()}`;
    }
}
